import { render, staticRenderFns } from "./updatemyinfo.vue?vue&type=template&id=515e64ae&scoped=true"
import script from "./updatemyinfo.vue?vue&type=script&lang=js"
export * from "./updatemyinfo.vue?vue&type=script&lang=js"
import style0 from "./updatemyinfo.vue?vue&type=style&index=0&id=515e64ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e64ae",
  null
  
)

export default component.exports